export const chipTypes = [
    "default", "unknownUser", "disabledUser", "user", "group", "file", "m_datamodel", "s_datamodel"
];
export const userIcon = Object.freeze({ name: "mdi-account-circle", color: "#4285F4" });
export const groupIcon = Object.freeze({ name: "mdi-account-supervisor-circle", color: "#4285F4" });
export const fileIcon = Object.freeze({ name: "mdi-cached", color: "#666666" });
